module.exports = __webpack_public_path__ + "static/img/banner-jian.f777f36.png";